(function () {
  'use strict';

  /*
    Carruseles con movimiento continuo + control manual.
    - Avanza solo, suave, y cambia de sentido al llegar a cada extremo.
    - Se detiene al tocar, arrastrar, usar la rueda, pasar el mouse,
      o al usar las flechas y puntos del carrusel.
    - Retoma el movimiento cuando el usuario deja de interactuar.
  */

  var SELECTOR = '[id^="yc-track-"], .fcp-grid';
  var SPEED_PX_PER_SECOND = 26;
  var RESUME_DELAY_MS = 2500;
  var USER_SCROLL_TOLERANCE_PX = 3;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initCarousel(track) {
    if (track.dataset.codexAutoplayReady === 'true') return;
    track.dataset.codexAutoplayReady = 'true';

    var direction = 1;
    var lastTimestamp = 0;
    var position = track.scrollLeft;
    var paused = false;
    var touching = false;
    var hovering = false;
    var focused = false;
    var visible = true;
    var snapDisabled = false;
    var resumeTimeoutId = null;
    var scope = track.closest('.shopify-section') || track.parentElement || track;

    function isHeld() {
      return touching || hovering || focused;
    }

    function canMove() {
      return track.scrollWidth > track.clientWidth + 5;
    }

    function pause() {
      paused = true;
      window.clearTimeout(resumeTimeoutId);
    }

    function resumeSoon() {
      window.clearTimeout(resumeTimeoutId);
      resumeTimeoutId = window.setTimeout(function () {
        if (isHeld()) return;
        paused = false;
        lastTimestamp = 0;
        position = track.scrollLeft;
      }, RESUME_DELAY_MS);
    }

    function animate(timestamp) {
      window.requestAnimationFrame(animate);

      if (!lastTimestamp) {
        lastTimestamp = timestamp;
        return;
      }

      var elapsedSeconds = Math.min((timestamp - lastTimestamp) / 1000, 0.05);
      lastTimestamp = timestamp;

      if (paused || isHeld() || !visible || document.hidden || reducedMotion.matches || !canMove()) return;

      if (!snapDisabled) {
        /* El ajuste magnético (scroll-snap) devuelve el carrusel a su sitio
           en cada cuadro e impide el movimiento continuo. */
        track.style.scrollSnapType = 'none';
        snapDisabled = true;
        position = track.scrollLeft;
      }

      var maxScroll = track.scrollWidth - track.clientWidth;
      position += direction * SPEED_PX_PER_SECOND * elapsedSeconds;

      if (position >= maxScroll) {
        position = maxScroll;
        direction = -1;
      } else if (position <= 0) {
        position = 0;
        direction = 1;
      }

      track.scrollLeft = position;
    }

    /* Dedo sobre el carrusel */
    track.addEventListener('touchstart', function () {
      touching = true;
      pause();
    }, { passive: true });

    function endTouch() {
      touching = false;
      resumeSoon();
    }
    track.addEventListener('touchend', endTouch, { passive: true });
    track.addEventListener('touchcancel', endTouch, { passive: true });

    /* Mouse sobre el carrusel (solo computador) */
    track.addEventListener('mouseenter', function () {
      if (!finePointer.matches) return;
      hovering = true;
      pause();
    });
    track.addEventListener('mouseleave', function () {
      if (!hovering) return;
      hovering = false;
      resumeSoon();
    });

    /* Rueda o trackpad */
    track.addEventListener('wheel', function () {
      pause();
      resumeSoon();
    }, { passive: true });

    /* Teclado */
    track.addEventListener('focusin', function () {
      focused = true;
      pause();
    });
    track.addEventListener('focusout', function () {
      focused = false;
      resumeSoon();
    });

    /* Flechas y puntos del carrusel (están fuera de la pista) */
    scope.addEventListener('pointerdown', function (event) {
      var button = event.target.closest('button');
      if (!button || track.contains(button)) return;
      pause();
      resumeSoon();
    }, true);

    /* Cualquier desplazamiento que no venga de este script es del usuario */
    track.addEventListener('scroll', function () {
      if (paused) {
        if (!isHeld()) resumeSoon();
        return;
      }
      if (Math.abs(track.scrollLeft - position) > USER_SCROLL_TOLERANCE_PX) {
        pause();
        resumeSoon();
      }
    }, { passive: true });

    /* No gastar recursos en carruseles fuera de pantalla */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) {
            lastTimestamp = 0;
            position = track.scrollLeft;
          }
        });
      }, { rootMargin: '200px 0px' }).observe(track);
    }

    window.requestAnimationFrame(animate);
  }

  function initAllCarousels(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  function boot() {
    initAllCarousels(document);
    document.addEventListener('shopify:section:load', function (event) {
      initAllCarousels(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
